<template>
  <footer
    class="footer"
    :class="{[`footer-${type}`]: type}"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
              <a href="https://www.boigner.digital" target="_blank" @click.prevent="redirect('bdweb')">
                Boigner Digital GmbH
            </a>
          </li>
          <li>
            <a href="https://www.boigner.digital/#/impressum" target="_blank" @click.prevent="redirect('bdimpressum')">
              Datenschutz, Impressum &amp; AGB
            </a>
          </li>
        </ul>

      </nav>
      <div class="copyright">
        &copy; {{ year }} - Boigner Digital GmbH
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data() {
      return {
        year: new Date().getFullYear(),
        redirecting: false
      }
    },
    methods: {
      async redirect(urlId) {
        const espoClient = this.useEspoClient();

        try {
          this.redirecting = true;
          const response = await espoClient.get(`redirect/${urlId}`);
          this.redirecting = false;
          
          if (response?.url) {
            window.open(response.url, '_blank');
          }
        } 
        catch {
        // Fail silently.
      }
        finally {
          this.redirecting = false;
        }
      }
    }
  }
</script>
<style>
</style>
